module.exports = __webpack_public_path__ + "static/coding_info_nontext_1_dont-ff6bcab542df2c5e338cff2e2bd59650.png";